<template>
	<div class="cards_container is-flex">
		<CardVentas v-for="(card, index) in displayCards" :key="index" v-bind="card" class="mr-4" />
	</div>
</template>

<script>
import { mapState } from "vuex";
import CardVentas from "@/components/financialReports/CardVentas.vue";
import {
	formatPercent,
	formatRangeLabel,
	indicesForRange,
	monthsBetween,
} from "@/views/financialReports/utils/periodFormatting";
import { emptyCard } from "@/views/financialReports/utils/summaryCards";

const EMPTY_CARD = () => emptyCard();

export default {
	name: "SalesSummaryCards",

	components: { CardVentas },

	props: {
		monthHeaders: { type: Array, required: true },
		tableRows: { type: Array, required: true },
		totalRow: { type: Object, required: true },
	},

	computed: {
		...mapState("salesReport", ["summaryCards"]),

		displayCards() {
			if (!this.summaryCards) {
				return [EMPTY_CARD(), EMPTY_CARD(), EMPTY_CARD()];
			}
			const { current_month, ytd, ltm } = this.summaryCards;
			return [
				this.buildCard(current_month, { showMom: true }),
				this.buildCard(ytd),
				this.buildCard(ltm),
			];
		},
	},

	methods: {
		buildCard(card, { showMom = false } = {}) {
			const indices = indicesForRange(this.monthHeaders, card.period_start, card.period_end);
			// Si el filtro de la tabla no cubre todo el período de la card,
			// no podemos derivar un breakdown coherente desde tableRows.
			const fullyInRange = indices.length === monthsBetween(card.period_start, card.period_end);
			return {
				period: formatRangeLabel(card.period_start, card.period_end),
				amount: card.amount,
				mom: showMom ? formatPercent(card.mom) : "",
				yoy: formatPercent(card.yoy),
				progressItems: fullyInRange
					? this.progressItemsForRange(indices, card.amount)
					: [],
			};
		},

		progressItemsForRange(indices, totalAmount) {
			return this.tableRows
				.map(row => {
					const rowTotal = indices.reduce(
						(sum, idx) => sum + (row.values[idx] || 0),
						0
					);
					const percent = totalAmount === 0 ? 0 : (rowTotal / totalAmount) * 100;
					return { label: row.label, percent: Math.round(percent) };
				})
				.sort((a, b) => b.percent - a.percent)
				.slice(0, 4);
		},
	},
};
</script>

<style scoped lang="scss">
.cards_container {
	width: 100%;
}
</style>
